export default __webpack_public_path__ + "static/media/THE-SIMPSONS-1.3fd99e75.png";